export default {
  contractMission: {
    contractMission: {
      title: ({ plural }) => plural(["Mission", "Missions"]),
      aiProposal: "AI proposal",
      activitiesLinked: ({ named }) => `${named("count")} linked activit${named("count") === 1 ? "y" : "ies"}`,
      levelOfAchievement: "Level of achievement",
      validate: "Validate this mission",
      decline: "Decline",
      merge: "Merge into...",
      defined: "Defined missions",
      no_missions: "No missions are defined on this contract.",
      import: "Import mission sheet",
      import_from_sheet: "Start adding some from a mission sheet",
      empty_no_sheet: "No missions are defined yet. Import a mission sheet to start tracking the apprentice.",
      empty_no_sheet_no_ia: "No missions are defined yet.",
      empty_no_sheet_cta: "Import a mission sheet",
      empty_has_sheet:
        "A mission sheet has been imported. Run the extraction to turn its content into missions to track.",
      empty_has_sheet_cta: "Run extraction",
      no_ia_alert: "Define and track the missions of your apprentice/intern in this tab",
      no_ia_alert_description: "Add a mission for your apprentice/intern",
    },
    import: {
      title: "Mission sheet splitting",
      intro: "AI identifies and reformulates missions from the sheet — you choose which ones to publish.",
      existing_sheet: "Mission sheet",
      upload_pdf: "Upload a PDF",
      free_text: "Or enter the content directly",
      free_text_placeholder: "Paste or type the content of your mission sheet…",
      or: "or",
      or_replace: "or upload another sheet",
      has_file_alert: "Sheet imported from the registration file",
      split_failed: "Automatic splitting failed. Please try running the splitting again.",
      launch: "Run extraction",
      loading_title: "Splitting in progress...",
      loading_subtitle: "AI is analysing and reformulating the missions",
      missions_proposed: "mission(s) proposed",
      validate_all: "Validate all",
      results_actions: "Actions on proposed missions",
      validate: "Validate",
      edit: "Edit",
      remove: "Remove",
      confirm_edit: "Confirm edit",
      field_name: "Mission name",
      field_description: "Mission description",
      no_missions: "No missions proposed.",
      publish: ({ named }) => `Publish ${named("count")} mission(s)`,
      publish_success: ({ named }) => `${named("count")} mission(s) published successfully`,
      removal_announcement: ({ named }) =>
        `Mission "${named("name")}" removed. ${named("count")} mission(s) proposed remaining.`,
    },
    banner: {
      title: "A mission sheet has been imported from the registration file",
      subtitle: "Split this sheet into missions to track the apprentice's progress throughout the apprenticeship",
      import: "Proceed with import",
      import_tooltip: "Open the mission sheet splitting modal",
      later: "Later",
      later_tooltip: "Hide this banner for this session",
    },
  },
};
